module.exports = __webpack_public_path__ + "static/a-xx-173-art-c4a378e710daa9368e251264851b2093.jpg";